import { render, staticRenderFns } from "./CompressedAnalysisNavigationTabs.vue?vue&type=template&id=6b38dc37&"
import script from "./CompressedAnalysisNavigationTabs.vue?vue&type=script&lang=ts&"
export * from "./CompressedAnalysisNavigationTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports